import React, { PropsWithChildren } from 'react';
import { clsx } from 'clsx';
import { Colors } from 'works/legacy/lib/style-helper';
import { Icon } from '@common/components';

export const VERTICAL_STEP_STATUSES = {
  wait: {
    color: Colors.steel,
    icon: <Icon icon="circle" kind="regular" color="steel" />,
  },
  process: {
    color: Colors.elm,
    icon: <Icon icon="circle" kind="regular" color="steel" />,
  },
  finish: {
    color: Colors.steel,
    icon: <Icon icon="checkCircle" kind="solid" color="grassMid" />,
  },
  error: {
    color: Colors.coral,
    icon: <Icon icon="timesCircle" kind="solid" color="coral" />,
  },
};

export type VerticalStepStatusType = 'wait' | 'finish' | 'error' | 'process';

type Props = {
  className?: string;
  status?: VerticalStepStatusType;
  hideIcon?: boolean;
};

export const VerticalStep = ({
  children,
  className,
  hideIcon = false,
  status = 'wait',
}: PropsWithChildren<Props>) => {
  return (
    <>
      <li
        className={clsx(
          'wk-vertical-step',
          `wk-vertical-step--${status}`,
          className
        )}
      >
        {!hideIcon && (
          <div className="wk-vertical-step__icon">
            {VERTICAL_STEP_STATUSES[status].icon}
          </div>
        )}
        <div className="wk-vertical-step__content">{children}</div>
      </li>
      <style jsx>{`
        .wk-vertical-step {
          border-radius: 4px;
          border: 1px solid ${VERTICAL_STEP_STATUSES[status].color};
          box-sizing: border-box;
          display: flex;
          flex-direction: row;
          padding: 16px;
          position: relative;
        }
        .wk-vertical-step__icon {
          margin-right: 8px;
        }
        .wk-vertical-step__content {
          width: 100%;
        }
        .wk-vertical-step--wait {
          background-color: ${Colors.steelLightest};
          border: 1px dashed ${Colors.steel};
        }
        .wk-vertical-step--process {
          box-shadow: 0 4px 8px 0 ${Colors.midnightRegular}40;
        }
      `}</style>
    </>
  );
};
